import {Image} from 'react-bootstrap';
import sportcastLogo from '../../../assets/SportcastLogoDataPrivacy.png';
import './LegalHeader.scss';

const DataPrivacyHeader = () => {
    return (
        <div className="terms-of-use-headline">
            <b>Datenschutzerklärung und Cookie-Richtlinie für das RePort-Portal der Sportcast</b>
            <p>
                <Image src={sportcastLogo} height={'75px'} width={'75px'} alt="Sportcast"/>
            </p>
        </div>
    );
};

export default DataPrivacyHeader;